import arigatoTemplate from './arigato/template.json';
import arigatoThumbnail from './arigato/thumbnail.webp';
// import classicTemplate from './classic/template.json';
import defaultTemplate from './default/template.json';
import defaultThumbnail from './default/thumbnail.webp';
import pizzaRedTemplate from './pizza-red/template.json';
import pizzaRedThumbnail from './pizza-red/thumbnail.webp';
import type { TemplateDefinition } from './types';

export const templates: TemplateDefinition[] = [
    {
        id: 'default',
        name: 'Výchozí',
        thumbnail: defaultThumbnail.src,
        template: defaultTemplate,
    },
    // {
    //     id: 'classic',
    //     name: 'Classic',
    //     thumbnail: null,
    //     template: classicTemplate,
    // },
    {
        id: 'pizza-red',
        name: 'Pizza Red',
        thumbnail: pizzaRedThumbnail.src,
        template: pizzaRedTemplate,
    },
    {
        id: 'arigato',
        name: 'Arigato',
        thumbnail: arigatoThumbnail.src,
        template: arigatoTemplate,
    },
];

export function getTemplateById(id: string): TemplateDefinition | undefined {
    return templates.find((t) => t.id === id);
}
